export const SEGMENTS = [
  { id: "assistencia", label: "Assistência Técnica" },
  { id: "refrigeracao", label: "Refrigeração / Ar-condicionado" },
  { id: "eletricista", label: "Eletricista" },
  { id: "informatica", label: "Informática" },
  { id: "celulares", label: "Celulares e Eletrônicos" },
  { id: "cabeleireiro", label: "Cabeleireiro" },
  { id: "barbeiro", label: "Barbeiro" },
  { id: "manicure", label: "Manicure" },
  { id: "estetica", label: "Estética" },
  { id: "oficina", label: "Oficina" },
  { id: "servicos", label: "Prestador de Serviços" },
  { id: "outros", label: "Outros" },
];

export const PAYMENT_METHODS = ["Dinheiro", "PIX", "Cartão de Crédito", "Cartão de Débito", "Transferência", "Boleto", "Outro"];

export const SEGMENT_FIELDS = {
  refrigeracao: [{ k: "pressao", label: "Pressão" }, { k: "temperatura", label: "Temperatura" }, { k: "carga_gas", label: "Carga de gás" }],
  assistencia: [{ k: "tensao", label: "Tensão (V)" }, { k: "acessorios", label: "Acessórios recebidos" }],
  eletricista: [{ k: "tensao", label: "Tensão (V)" }, { k: "carga", label: "Carga / Disjuntor" }],
  celulares: [{ k: "imei", label: "IMEI" }, { k: "senha", label: "Senha/Padrão (se autorizado)" }, { k: "acessorios", label: "Acessórios" }],
  informatica: [{ k: "so", label: "Sistema Operacional" }, { k: "backup", label: "Backup realizado?" }],
  cabeleireiro: [{ k: "profissional", label: "Profissional" }, { k: "produto", label: "Produto utilizado" }, { k: "proximo_agendamento", label: "Próximo agendamento", type: "date" }],
  barbeiro: [{ k: "profissional", label: "Profissional" }, { k: "produto", label: "Produto utilizado" }, { k: "proximo_agendamento", label: "Próximo agendamento", type: "date" }],
  manicure: [{ k: "profissional", label: "Profissional" }, { k: "produto", label: "Produto / Esmalte" }, { k: "proximo_agendamento", label: "Próximo agendamento", type: "date" }],
  estetica: [{ k: "profissional", label: "Profissional" }, { k: "procedimento", label: "Procedimento" }, { k: "proximo_agendamento", label: "Próximo agendamento", type: "date" }],
  oficina: [{ k: "placa", label: "Placa" }, { k: "km", label: "Quilometragem" }, { k: "combustivel", label: "Nível de combustível" }],
};
export const PAYMENT_STATUS = ["PAGO", "PENDENTE", "PARCIAL", "CANCELADO"];
export const DOC_STATUS = ["Rascunho", "Enviado", "Aguardando aprovação", "Enviado para assinatura", "Visualizado", "Assinado", "Aprovado", "Recusado", "Expirado", "Convertido em serviço", "Aberta", "Em andamento", "Aguardando peça", "Finalizada", "Concluído", "Cancelado"];
export const BUDGET_STATUS = ["Rascunho", "Enviado", "Aguardando aprovação", "Aprovado", "Recusado", "Expirado", "Convertido em serviço"];
export const SERVICE_STATUS = ["Aberta", "Em andamento", "Aguardando peça", "Finalizada", "Cancelado"];

export const DOC_TYPES = {
  budget: { label: "Orçamento", plural: "Orçamentos", icon: "FileText", color: "text-blue-600" },
  service_order: { label: "Ordem de Serviço", plural: "Ordens de Serviço", icon: "ClipboardList", color: "text-orange-600" },
  report: { label: "Laudo Técnico", plural: "Laudos Técnicos", icon: "FileSearch", color: "text-purple-600" },
  nota_servico: { label: "Nota de Serviço", plural: "Notas de Serviço", icon: "Receipt", color: "text-emerald-600" },
  recibo: { label: "Recibo", plural: "Recibos", icon: "Wallet", color: "text-teal-600" },
  contrato: { label: "Contrato", plural: "Contratos", icon: "FileSignature", color: "text-indigo-600" },
  proposta_comercial: { label: "Proposta Comercial", plural: "Propostas Comerciais", icon: "Briefcase", color: "text-amber-600" },
};

export const STATUS_STYLES = {
  "Rascunho": "bg-slate-100 text-slate-600 border-slate-200",
  "Enviado": "bg-amber-100 text-amber-700 border-amber-200",
  "Aguardando aprovação": "bg-amber-100 text-amber-700 border-amber-200",
  "Expirado": "bg-slate-200 text-slate-600 border-slate-300",
  "Convertido em serviço": "bg-purple-100 text-purple-700 border-purple-200",
  "Aberta": "bg-sky-100 text-sky-700 border-sky-200",
  "Em andamento": "bg-blue-100 text-blue-700 border-blue-200",
  "Aguardando peça": "bg-orange-100 text-orange-700 border-orange-200",
  "Finalizada": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Enviado para assinatura": "bg-amber-100 text-amber-700 border-amber-200",
  "Visualizado": "bg-sky-100 text-sky-700 border-sky-200",
  "Assinado": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Aprovado": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Concluído": "bg-purple-100 text-purple-700 border-purple-200",
  "Recusado": "bg-red-100 text-red-700 border-red-200",
  "Cancelado": "bg-red-100 text-red-700 border-red-200",
  "PAGO": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "PENDENTE": "bg-amber-100 text-amber-700 border-amber-200",
  "PARCIAL": "bg-sky-100 text-sky-700 border-sky-200",
  "CANCELADO": "bg-red-100 text-red-700 border-red-200",
};

export const formatBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(v || 0));
